/**
 * Company: SPHMedia
 * Description: [President Address Banner]
 */

import { PRESIDENT_ADDRESS_PAGE } from "@config/presidentAddress";
import Link from "@elements/Typography/Link";
import { ReactElement } from "react";

import { PresidentAddressIcon } from "./PresidentAddressIcon";

/**
 * PresidentAddressBanner
 * Description: [President Address Banner component]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function PresidentAddressBanner({
  isLive,
}: {
  isLive: boolean;
}): ReactElement {
  const landingPagePath = `${PRESIDENT_ADDRESS_PAGE}?ref=banner`;

  return (
    <div className="flex justify-center items-center bg-gradient-to-r from-blue-950 to-red-450 py-1">
      <div className="gap-2.5 lg:gap-2 h-[52px] lg:h-[37px] items-center hidden md:flex">
        <PresidentAddressIcon isLive={isLive} variant="banner" />
        <Link
          destination={landingPagePath}
          className="text-xs font-medium lg:text-md lg:font-semibold text-text-inverse font-primary underline leading-[normal]"
        >
          Ikuti liputan sidang Parlimen kami
        </Link>
      </div>
      <div className="h-[58px] flex md:hidden gap-2 items-center justify-center">
        <PresidentAddressIcon isLive={isLive} variant="banner" />
        <div className="flex flex-col gap-[2px]">
          <Link
            destination={landingPagePath}
            className="text-[14px] font-medium text-text-inverse font-primary underline leading-[20px]"
          >
            Ikuti liputan sidang Parlimen kami
          </Link>
        </div>
      </div>
    </div>
  );
}
